<template>
    <div v-if="cropperiod">

        <!-- Modal 按鈕 -->
        <b-button class="add-note"
                  v-b-modal="modalID"
                  variant="success" >
            <i class="fa fa-plus"></i> 農務工作
        </b-button>



        <!-- Modal 內容 -->
        <b-modal hide-header-close ok-only size="md"
                :id="modalID" ref="modal"
                @shown="showModal()"
                header-text-variant="light"
                header-bg-variant="teal" >
            <!-- header -->
            <div slot="modal-header" v-html="$t('menu.upload') + ' ' + $t('menu.farming_activity')"></div>

            <div>

                <b-row align-h="center">
                    <b-col sm="10">
                        <!-- Image -->
                        <div class="upload-img-area" v-show="!edit.pic">
                            <!-- <h4 class="card-title agri-color"><i class="fa fa-plus"></i> {{ $t('menu.upload_image') }}</h4> -->
                            <div class="upload-img-preview cover-bg" alt="Cropping Season Photo" :style="$tools.style.imgCover( $config.checkURL('photo', pic_preview) )"></div>

                            <div class="upload-img-button">
                                <file-upload extensions="jpg,jpeg,png,gif" accept="image/png,image/gif,image/jpeg,image"
                                            :size="1024 * 1024 * 2" :drop="true" name="pic" class="btn btn-success btn-upload"
                                            v-model="pic_files" @input-filter="image_inputFilter" @input-file="check_inputFile_pic"
                                            :disabled="uploading" ref="upload">
                                            <i class="fa fa-camera"></i>
                                            {{ $t('menu.select') }}
                                </file-upload>
                            </div>
                        </div>

                        <div class="upload-img-edit" v-show="pic_files.length && edit.pic">
                            <vue-cropper v-if="pic_files.length && edit.pic" ref="cropper" :src="pic_preview" :info="true"
                                :aspectRatio="1.5" :fixedBox="true" :centerBox="true" :canScale="true" alt="Theme Image">
                            </vue-cropper>

                            <div class="float-right">
                                <button type="button" class="btn btn-secondary btn-upload" @click.prevent="reset_imagePreview"
                                            :disabled="uploading">
                                            <i class="fa fa-close"></i> {{ $t('menu.cancel') }}
                                </button>
                                <button type="button" class="btn btn-success btn-upload" @click.prevent="resize_imagePreview(pic_files)"
                                            :disabled="uploading">
                                            <i class="fa fa-close"></i> {{ $t('menu.confirm') }}
                                </button>
                            </div>
                        </div>

                        <div>
                            <div>
                                <div class="block-text-sm"><i class="fa fa-calendar"></i>{{ $t('u.date') }}</div>
                                <date-picker v-model="input_date" :lang="$tools.lang.date_picker(language)"
                                            :clearable="false" :width="'200px'" :placeholder="$t('menu.select_date')" format="YYYY-MM-DD HH:mm"></date-picker>
                            </div>
                            <div>
                                
                                <div class="block-text-sm"><i class="fa fa-calendar"></i>{{ $t('menu.farming_activity') }}</div>
                                <b-dropdown id="ddown-left" :text="( input_action ? input_action : '請選擇工作項目' )" variant="primary" class="m-2" size="lg">
                                    <b-dropdown-item @click="input_action = 'Action 1'">Action 1</b-dropdown-item>
                                    <b-dropdown-item @click="input_action = 'Action 2'">Action 2</b-dropdown-item>
                                    <b-dropdown-item @click="input_action = 'Action 3'">Action 3</b-dropdown-item>
                                </b-dropdown>
                            </div>

                        </div>
                    </b-col>
                </b-row>


            </div>

            <div slot="modal-footer" class="w-100">
                <div class="float-left">
                    <!-- HashTag -->
                    <i class="fa fa-hashtag"></i>{{ cropperiod.name }}
                    
                </div>
                
                <b-btn class="btn-agri float-right" variant="success" @click="uploadNote()" :disabled="checkDisabled">{{ $t('menu.upload') }}</b-btn>
                <b-btn class="btn-agri float-right" variant="secondary" @click="closeModal()">{{ $t('menu.cancel') }}</b-btn>
            </div>
        </b-modal>

    </div>
</template>


<script>
import { mapState } from 'vuex'
import VueCropper from 'vue-cropperjs';
import FileUpload from 'vue-upload-component'
import DatePicker from 'vue2-datepicker'

export default {
    props: {

        cropperiod: {
            type: Object,
            required: true,
        },

    },
    components: {
        FileUpload,
        DatePicker,
    },
    data () {
        return {
            modalID: 'farm-work-modal-',

            input_date: '',
            input_action: undefined,
            
            pic_preview: undefined,
            pic_files: [],
            edit: {
                pic: false,
            },
            uploading: false,
        }
    },
    mounted () {

    },
    computed: {
        ...mapState({
            'user_admin': state => state.user.is_admin,
            'language': state => state.user.language,
        }),

        checkDisabled() {
            if (this.input_action == undefined) return true;
            if (this.input_date == undefined || this.input_date == '') return true;
            return false;
        },
    },
    watch: {

        pic_files() {
            if (this.pic_files.length > 0) {
                this.pic_preview = this.pic_files[0].url;
            }
        },

    },
    methods: {

        showModal ()
        {
            this.input_date = this.$moment(new Date()).format('YYYY-MM-DD HH:mm')
            this.input_action = ''
            this.pic_preview = undefined
            this.edit.pic = false
            this.uploading = false;
        },

        closeModal ()
        {
            this.$refs.modal.hide()
        },

        upload_NotePhoto ()
        {
            this.uploading = true;

            // 圖片轉檔準備
            let _photo = this.pic_files[0]
            let _photoType = _photo
            let _uploadPhoto = undefined

            if ( this.pic_preview && _photo && _photo.file )
            {
                let _binStr = atob( this.pic_preview.split(',')[1] );
                let _arr = new Uint8Array(_binStr.length);
                for (let i = 0; i < _binStr.length; i++) {
                    _arr[i] = _binStr.charCodeAt(i);
                }
                _uploadPhoto = new File([_arr], _photo.name, {
                    type: 'image/jpeg'
                });
            }
            
            // API 資料準備
            let _api_url = undefined;       // 設定 API URL 的地方
            let _formData = new FormData();
            _formData.append('pic', _info.file, _info.file.name);

            const options = {
                method:'POST',
                url: _api_url,
                headers: { 'Content-Type': 'multipart/form-data' },
                data: _formData,
            }
            this.$http(options)
            .then( res => {
                // console.log(res)
                this.uploading = false;

                
                // 須回報成功，可以考慮使用 toastr
                // this.$toastr.s(this.$t('other.update_succeeded'), '紀錄上傳成功');
                this.closeModal(); // 成功就關掉 Modal
            })
            .catch( err => {
                // console.log(err)
                this.uploading = false;
                // 須回報錯誤
            })
        },

        uploadNote ()
        {
            // First Step：Upload Note Content
            this.uploading = true;
            const options = {
                method:'POST',
                url:    _api_url,   // API URL
                data:   _note_data, // Note Data
            }
            this.$http(options)
                .then( res => {
                    // console.log(res)
                    this.uploading = false;

                    // Second Step：Upload Note Photo
                    this.upload_NotePhoto();
                })
                .catch( err => {
                    // console.log(err)
                    this.uploading = false;
                    // 須回報錯誤
                })

        },

        // 將 cropper 切裁後的圖片指定給 pic_preview 圖片預覽
        resize_imagePreview (files)
        {
            if (files[0] && files[0].file)
            {
                let _oldFile = files[0].file;
                let _fileOptions = {
                    maxWidth: 1024,
                    minWidth: 600,
                };
                this.pic_preview = this.$refs.cropper.getCroppedCanvas(_fileOptions).toDataURL(_oldFile.type)
            }
            this.uploading = false;
            this.edit.pic = false;
        },

        // 取消圖片預覽
        reset_imagePreview (doCreate = false)
        {
            this.pic_files = []
            if (doCreate) this.pic_preview = undefined
            else this.pic_preview = this.cropperiod_detail.pic
            this.uploading = false;
            this.edit.pic = false;
        },

        check_inputFile_pic (newFile, oldFile, prevent)
        {
            this.$tools.input.check_inputFile(newFile, oldFile, prevent, this, 'pic')
        },
        image_inputFilter (newFile, oldFile, prevent)
        {
            this.$tools.input.image_inputFilter(newFile, oldFile, prevent, this)
        },
    }
}
</script>

<style lang="scss" scoped>

.modal-header
{
    background-color: #216a53 !important;
}

</style>
